<template>
<div class="container container--narrow pdt-50 pdb-50">
	<div class="t-subtitle6 font-r  t-line-h-26 d-flex -align-items-center">
		{{ question.number }}. {{ question.contents.text }}
		<span class="t-color-mainBtn" v-if="question.essential">*</span>
	</div>
	<div class="mgt-24" v-if="question.contents && question.contents.image">
			<img :src="question.contents.image" alt="" class="b-radius4 survey-banner">
	</div>
	<div class="mgt-24">
	<div v-for="(choice, index) in question.choices"
				:key="choice.id"
				@click="setSelected(index)" @keypress="setSelected(index)">
		<div class="mgb-8 pdt-7 pdb-7 pdl-14 radio-wrapper b-radius4" :class="{ selected: selected[index] }">
				<div class="mdc-form-field">
						<div class="mdc-radio customize-radio">
								<input class="mdc-radio__native-control" 
									type="radio" 
									:value="true"
									:id="`radio_${choice.id}`"
									v-model="selected[index]"
									@click="setSelected(index)" @keypress="setSelected(index)" tabindex="0">
								<div class="mdc-radio__background">
									<div class="mdc-radio__outer-circle"></div>
									<div class="mdc-radio__inner-circle"></div>
								</div>
								<div class="mdc-radio__ripple"></div>
						</div>
						<label :for="`radio_${choice.id}`" :class="selected[index] ? 't-color-whiteHigh' : 't-color-quizBlack'" class="t-body1 font-r t-line-h-20 pdl-6">
								{{ choice.contents }}
						</label>
				</div>
				<div class="mgt-16 mgl-50 mgr-24 mgb-16" v-if="choice.image">
					<img :src="choice.image" alt="" class="b-radius4 survey-q-banner">
				</div>
		</div>
		</div>
		<div v-if="question && question.commentAllow===true" @click="setSelectedEtc()" @keypress="setSelectedEtc()" tabindex="0">
		<div class="mgb-8 pdt-7 pdb-16 pdl-14 pdr-24 radio-wrapper b-radius4" :class="selectedEtc ? 'selected' : ''">
				<div class="mdc-form-field w-full">
				<div class="mdc-radio customize-radio radio-with-input mdc-radio--disabled">
						<input class="mdc-radio__native-control" type="radio"                   
							:value="true"
							:id="'radioEtc'"
							v-model="selectedEtc"
							@click="setSelectedEtc()" @keypress="setSelectedEtc()" tabindex="0"
						>
						<div class="mdc-radio__background">
								<div class="mdc-radio__outer-circle"></div>
								<div class="mdc-radio__inner-circle"></div>
						</div>
						<div class="mdc-radio__ripple"></div>
				</div>
				<label :for="'radioEtc'" :class="selectedEtc ? 't-color-whiteHigh' : 't-color-quizBlack'" class="t-body1 font-r t-line-h-20 pdl-6">
					{{ $t("754") }}
				</label>
					</div>
					<div class="mgl-50">
				<div
						class="mdc-text-field mdc-text-field--outlined w-full customize-input customize-input-radio radio-wrapper-dark"
						data-mdc-auto-init="MDCTextField" v-show="selectedEtc" :id="`comment`">
						<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading" style="border-color:var(--DocumentWhite)!important"></span>
								<span class="mdc-notched-outline__notch min-w-90">
										<!-- <span class="mdc-floating-label t-body3 t-color-textfieldGuid"
												id="my-label-id">기타 의견 입력</span> -->
								</span>
								<span class="mdc-notched-outline__trailing" style="border-color:var(--DocumentWhite)!important"></span>
						</span>
						<input type="text" class="mdc-text-field__input t-color-whiteHigh pdl-10 caret-color-data"
							maxlength="50"
							autocomplete="off"
							v-model="comment" />
				</div>
				</div>
				</div>
			</div>
	</div>
	</div>
</template>

<script>
/**
 * 설문 - 단일응답 문항 컴포넌트(survey - choice single question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCTextField } from "@material/textfield";

export default {
	props: ["question", "setedAnswer"],
	data() {
		return {
			selected: [],
			selectedEtc: false,
			comment: "",
		};
	},
	mounted() {
		this.selected = this.setedAnswer.selected;
		const textField = new MDCTextField(document.getElementById("comment"));

		if (this.setedAnswer.comment) {
			this.selectedEtc = true;
			this.comment = this.setedAnswer.comment;
		}
	},

	watch: {
		comment: function (value) {
			this.setAnswer();
		},
	},

	methods: {
		//답안 설정(set answer)
		setSelected(selectedIndex) {
			this.initSelected();
			this.selectedEtc = false;
			this.comment = "";

			for (var i = 0; i < this.selected.length; i++) {
				if (i === selectedIndex) {
					this.selected[i] = true;
				}
			}

			this.setAnswer();
		},

		// 기타의견 설정(set etc comment)
		setSelectedEtc() {
			this.selectedEtc = true;
			this.initSelected();
			this.setAnswer();
		},

		// 답안 초기화(init answer)
		initSelected() {
			this.selected = _(this.question.choices.length).times(() => {
				return false;
			});
		},

		//답안정보 설정 및 부모 컴포넌트에 전달(set answer / transfer parent component)
		setAnswer() {
			let params = {
				questionId: this.question.id,
				text: "",
				comment: this.comment,
				selected: this.selected,
				weight: {},
				isSolved: this.isSolved(),
			};

			this.$emit("setAnswers", params);
		},

		// 응답 여부 확인(check solved )
		isSolved() {
			return (
				_.includes(this.selected, true) || (this.selectedEtc && !!this.comment)
			);
		},
	},
};
</script>
<style scoped>
#comment .caret-color-data{
	caret-color:var(--WhiteHigh)!important;
}
</style>